module.exports = __webpack_public_path__ + "img/syukyaku-sytem-ira004.53520ef0.png";